export function allServicesOf(source) {
    var _ref, _ref1;
    var _source_serviceBundles;
    return [
        ...(_ref = source === null || source === void 0 ? void 0 : source.services) !== null && _ref !== void 0 ? _ref : [],
        ...((_ref1 = source === null || source === void 0 ? void 0 : (_source_serviceBundles = source.serviceBundles) === null || _source_serviceBundles === void 0 ? void 0 : _source_serviceBundles.bundles) !== null && _ref1 !== void 0 ? _ref1 : []).flatMap((bundle)=>bundle.services)
    ];
}
